import { useLanguage } from "@context/use-language";
import { useAuthUser } from "@data/auth";
import { Button, Header, HeaderNavMenuItem, LoadingSpinnerSmall, Typography } from "@dm-4dev/ui";
import { useAuthStore } from "@mod/auth";
import { useSocket } from "@mod/core/hooks/use-socket";
import { useIsMobile } from "@mod/core/utils/use-is-mobile";
import { LeftMenuMobile } from "@route/layout/ui/left-menu-mobile";
import clsx from "clsx";
import LogRocket from "logrocket";
import { LogOutIcon, MenuIcon, UserCircle2Icon } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../router";

export const UserHeaderWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData, isFetching } = useAuthUser();
  const isMobile = useIsMobile();
  const isHome = location.pathname === APP_ROUTES.HOME;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useLanguage();
  const { isConnected } = useSocket();

  const logOutAction = useAuthStore.use.logout();
  const userMenuOptions: HeaderNavMenuItem[] = [
    {
      label: t("myProfile"),
      buttonProps: {
        onClick: () => {
          navigate(APP_ROUTES.PROFILE);
        },
        "aria-label": "profile",
        variant: "text",
        align: "left",
        fullWidth: true,
        startIcon: <UserCircle2Icon size={16} />,
        className: "text-primary"
      }
    },
    // {
    //   label: t("groups"),
    //   buttonProps: {
    //     onClick: () => {
    //       navigate(APP_ROUTES.GROUPS);
    //     },
    //     "aria-label": "settings",
    //     variant: "text",
    //     align: "left",
    //     fullWidth: true,
    //     startIcon: <CogIcon size={16} />,
    //     className: "text-primary"
    //   }
    // },
    // {
    //   label: t("settings"),
    //   buttonProps: {
    //     onClick: () => {
    //       // navigate(APP_ROUTES.SETTINGS);
    //     },
    //     "aria-label": "settings",
    //     variant: "text",
    //     align: "left",
    //     fullWidth: true,
    //     startIcon: <CogIcon size={16} />,
    //     className: "text-primary"
    //   }
    // },
    {
      label: t("logout"),
      buttonProps: {
        onClick: () => {
          logOutAction();
          navigate(APP_ROUTES.LOGIN);
        },
        "aria-label": "logout",
        variant: "text",
        align: "left",
        fullWidth: true,
        startIcon: <LogOutIcon size={16} />,
        className: "text-primary"
      }
    }
  ];

  // const navButtonProps = (selected?: boolean): ButtonProps => ({
  //   className: clsx("hover:bg-white hover:text-primary focus:bg-violet-500", {
  //     "!bg-primary !bg-opacity-5": selected
  //   }),
  //   size: "sm",
  //   variant: "text"
  // });

  useEffect(() => {
    if (!userData?.id) return;

    LogRocket.identify(userData?.id, {
      name: userData?.displayName,
      email: userData?.username
    });
  }, [userData]);

  const userAvatarComponent = isFetching ? (
    <LoadingSpinnerSmall size="md" color="white" />
  ) : (
    <Typography variant={isMobile ? "label" : "title"} className="text-inherit px-1 flex gap-2">
      <UserCircle2Icon
        className={clsx("", {
          "text-red-500": !isConnected,
          "text-green-600": isConnected
        })}
      />
      {userData?.displayName}
    </Typography>
  );

  return (
    <>
      <Header
        logo={
          <div className="flex gap-2 ml-2 items-center">
            {!isHome && (
              <>
                <Link to={APP_ROUTES.HOME} className="z-10">
                  <img src="/comu-app-logo.png" alt="logo" className="h-11 w-auto" />
                </Link>
                <Button variant="text" onClick={() => setIsMenuOpen(true)} className="z-10 !px-2 mr-2">
                  <MenuIcon size={24} className="text-whitemd:text-primary" />
                </Button>
              </>
            )}
          </div>
        }
        userAvatar={userAvatarComponent}
        className={clsx(
          "bg-primary text-primary-text items-center flex relative z-40 py-4 md:py-2 shadow-md whitespace-break-spaces"
        )}
        userMenu={userMenuOptions}
        navmenu={[]}
      />
      {(isMobile || (!isMobile && !isHome)) && (
        <LeftMenuMobile isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      )}
    </>
  );
};
